import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { keyframes } from 'styled-components';
const box1 = keyframes `
  0%, 50% {
    transform: translate(100%, 0);
  }
  100% {
    transform: translate(200%, 0);
  }
`;
const box2 = keyframes `
  0% {
    transform: translate(0, 100%);
  }
  50% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(100%, 0);
  }
`;
const box3 = keyframes `
  0%, 50% {
    transform: translate(100%, 100%);
  }
  100% {
    transform: translate(0, 100%);
  }
`;
const box4 = keyframes `
  0% {
    transform: translate(200%, 0);
  }
  50% {
    transform: translate(200%, 100%);
  }
  100% {
    transform: translate(100%, 100%);
  }
`;
const LoaderContainer = styled.div `
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;
const BoxesContainer = styled.div `
  --size: 24px;
  --duration: 800ms;
  height: calc(var(--size) * 2);
  width: calc(var(--size) * 3);
  position: relative;
  transform-style: preserve-3d;
  transform-origin: 50% 50%;
  margin-top: calc(var(--size) * 1.5 * -1);
  transform: rotateX(60deg) rotateZ(45deg) rotateY(0deg) translateZ(0px);
`;
const Box = styled.div `
  width: var(--size);
  height: var(--size);
  position: absolute;
  transform-style: preserve-3d;

  &:nth-child(1) {
    transform: translate(100%, 0);
    animation: ${box1} var(--duration) linear infinite;
  }

  &:nth-child(2) {
    transform: translate(0, 100%);
    animation: ${box2} var(--duration) linear infinite;
  }

  &:nth-child(3) {
    transform: translate(100%, 100%);
    animation: ${box3} var(--duration) linear infinite;
  }

  &:nth-child(4) {
    transform: translate(200%, 0);
    animation: ${box4} var(--duration) linear infinite;
  }
`;
const BoxFace = styled.div `
  --background: #2fd841;
  --top: auto;
  --right: auto;
  --bottom: auto;
  --left: auto;
  --translateZ: calc(var(--size) / 2);
  --rotateY: 0deg;
  --rotateX: 0deg;
  position: absolute;
  width: 100%;
  height: 100%;
  background: var(--background);
  top: var(--top);
  right: var(--right);
  bottom: var(--bottom);
  left: var(--left);
  transform: rotateY(var(--rotateY)) rotateX(var(--rotateX))
    translateZ(var(--translateZ));
  border: 1px solid #103110;

  &:nth-child(1) {
    --top: 0;
    --left: 0;
  }

  &:nth-child(2) {
    --background: #01b135;
    --right: 0;
    --rotateY: 90deg;
  }

  &:nth-child(3) {
    --background: #019245;
    --rotateX: -90deg;
  }

  &:nth-child(4) {
    --background: #dddddd;
    --top: 0;
    border: none;
    --left: 0;
    --translateZ: calc(var(--size) * 3 * -1);
  }
`;
const Loader = () => {
    return (_jsx(LoaderContainer, { children: _jsxs(BoxesContainer, { children: [_jsxs(Box, { children: [_jsx(BoxFace, {}), _jsx(BoxFace, {}), _jsx(BoxFace, {}), _jsx(BoxFace, {})] }), _jsxs(Box, { children: [_jsx(BoxFace, {}), _jsx(BoxFace, {}), _jsx(BoxFace, {}), _jsx(BoxFace, {})] }), _jsxs(Box, { children: [_jsx(BoxFace, {}), _jsx(BoxFace, {}), _jsx(BoxFace, {}), _jsx(BoxFace, {})] }), _jsxs(Box, { children: [_jsx(BoxFace, {}), _jsx(BoxFace, {}), _jsx(BoxFace, {}), _jsx(BoxFace, {})] })] }) }));
};
export default Loader;
